export default {
    title: 'Your organization competencies',
    description:
        'When an evaluation includes a competency, the related questions will be automatically added. The {{managerLabel}} can then edit or remove them as needed.',
    competencies: 'Competencies',
    profiles: 'Profiles',
    levels: 'Levels',
    translations: 'Translations',
};
